export default "__VITE_ASSET__1whPVDIQ__"